
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teams/[genreSlug]/[slug]/news",
      function () {
        return require("private-next-pages/teams/[genreSlug]/[slug]/news/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/teams/[genreSlug]/[slug]/news"])
      });
    }
  